import React, { Component } from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import moment from 'moment';

class VisitorPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //itemsIndex:this.props.visitorReducer.VisitorIndex.index
    };
  }
  // handelNex = () =>{
  //     var indexOfVisitor= indexid.index;

  // }
  visitorStatus = [
    'Details pending',
    'Details uploaded',
    'Details approved',
    'Checked-in',
    'Details rejected',
    'Visit cancelled',
    'Checked-out',
  ];

  render() {
    const setViewData = this.props.visitor;
    const visitarall = this.props.visitorReducer.VisitorTableData;
    const indexid = this.props.visitorReducer.VisitorIndex;

    return (
      <>
        <div className="row mb-3">
          <div className="col-3">
            <div className="ProfilePic_100x100">
              <img
                src={setViewData.profile_picture}
                className="img-responsive"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="SwFormGroup">
              <div className="SwTextGray">Visitor Name</div>
              <div className='SwTextDark'>{setViewData.fname}</div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="SwFormGroup">
              <div className="SwTextGray">Host Name</div>
              <div className='SwTextDark'>{setViewData.hfirstname}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="SwFormGroup">
              <div className="SwTextGray">Phone No.</div>
                <div className='SwTextDark'>{setViewData.phone}</div>
            </div>
          </div>
          <div className="col-md-6">
                   <div className="SwFormGroup">
           <div className="SwTextGray">Location.</div>
              <div className='SwTextDark'>{setViewData.location || setViewData.name || '--'}</div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 ">
               <div className="SwFormGroup">
              <div className="SwTextGray">Host Email</div>
            <div className='SwTextDark'>{setViewData.hemail}</div>
            </div>
          </div>
          <div className="col-md-6">
          <div className="SwFormGroup">
              <div className="SwTextGray">Purpose of Visit</div>
                  <div className='SwTextDark'>{setViewData.purpose}</div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
        <div className="SwFormGroup">
                <div className="SwTextGray">In Date & Time</div>
           <div className='SwTextDark'>
                {' '}
                <Moment parse="YYYY-MM-DD HH:mm">{setViewData.in_time}</Moment>
              </div>
            </div>
          </div>
          <div className="col-md-6">
          <div className="SwFormGroup">
                  <div className="SwTextGray">Out Date & Time</div>
             <div className='SwTextDark'>
                {setViewData.out_time === null ? (
                  '  --'
                ) : (
                  <Moment parse="YYYY-MM-DD HH:mm">
                    {setViewData.out_time}
                  </Moment>
                )}{' '}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
      <div className="SwFormGroup">
          <div className="SwTextGray">Visitor Type</div>
              <div className='SwTextDark'>{setViewData.visitor_type == 1 ? 'Walk-In' : 'Pre-Invite'}</div>
            </div>
          </div>
          <div className="col-md-6">
                <div className="SwFormGroup">
               <div className="SwTextGray">Current Status</div>
             <div className='SwTextDark'>
                {setViewData?.approve_by_client &&
                  this.visitorStatus[setViewData.approve_by_client]}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  visitorReducer: state.visitorReducer,
});

export default connect(mapStateToProps)(VisitorPopUp);
